import React from "react"
import { graphql } from "gatsby"
import LayoutListado from "../components/layoutListado"
import SEO from "../components/seo"
import ListadoScreen from "../components/evento/ListadoScreen"

const ListadoPage = ({ data }) => {
  const eventosData = data.allApiExternaEventosNext.edges.map(edge => edge.node)

  const variablesEntorno = {
    AGENDA_APP_SITE: data.site.siteMetadata.AGENDA_APP_SITE,
  }

  return (
    <LayoutListado>
      <SEO title="Listado" pathname="/listado" />

      <ListadoScreen eventosData={eventosData} variablesEntorno={variablesEntorno} />
    </LayoutListado>
  )
}

export default ListadoPage

export const pageQuery = graphql`
  query ListadoQuery {
    site {
      siteMetadata {
        title
        AGENDA_APP_SITE
      }
    }
    allApiExternaEventosNext(filter: { id: { ne: "dummy" } }) {
      edges {
        node {
          slug
          EventoDestacado
          ImagenDestacada {
            alternativeText
            alternative_id
            ext
            name
            mime
            height
            provider
            size
            url
            width
          }
          Titulo
          Fechas {
            Fecha
            Fin
            Inicio
            _xcomponent
            alternative_id
          }
          WorkFlow
          alternative_id
          area_tematicas {
            Nombre
            alternative_id
          }
          tipo_evento {
            Nombre
            TipoEvento
            alternative_id
          }
          id
          Lugar {
            DescripcionLink
            DescripcionLugar
            URL
            Ubicacion
            agenda_master_lugar_pucp {
              Nombre
              alternative_id
            }
            alternative_id
            _xcomponent
          }
        }
      }
    }
  }
`
